import { useState } from "react";
import { useForm } from "react-hook-form";
import { useAlert } from '../../../shared/components/AlertProvider';
import Flex from '../../../shared/components/Flex';
import Grid from '../../../shared/components/Grid';
import GridChild from '../../../shared/components/GridChild';
import LabelInput from '../../../shared/components/LabelInput';
import ModalButton from '../../../shared/components/ModalButton';
import Spacer from '../../../shared/components/Spacer';
import ToggleButtonSelect from '../../../shared/components/ToggleSelect';
import useDevice from '../../../shared/hooks/useDevice';
import { responseMsg } from "../../common/ResponseMsg";

function CodeAddModal({rendering,type,selectedCode1,selectedCode2}) {
    const { register, handleSubmit, formState: { isSubmitting, isDirty, errors }} = useForm();
    const device = useDevice();
    const isMobile = device !== 'desktop';
    const [useYn, setUseYn] = useState('Y');
    const showAlert = useAlert();

    const useYnOption = [
        {text: "사용", value: "Y"},
        {text: "미사용", value: "N"}
    ]

    const onSubmitHandler = (formData) => {
        if (formData.name.trim() === '') {
            showAlert({title: "주의", text: "코드명을 입력해주세요.", type: "warning" });
            return;
        }

        if (type === 'Level 2') {
            formData = {
                ...formData,
                groupCode: selectedCode1.groupCode,
                parent: selectedCode1.id,
                useYn: useYn,
                depth: 2,
            }

        } else if (type === 'Level 3') {
            formData = {
                ...formData,
                groupCode: selectedCode1.groupCode,
                parent: selectedCode2.id,
                useYn: useYn,
                depth: 3,
            }
        }

        fetch("/api/system/codes",{
            method:"POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((res) => res.json())
            .then((json) => {
                if (json.code === responseMsg.SUCCESS.code) {
                    showAlert({title: "알림", text: "등록완료"});
                    rendering();

                } else if (json.code === responseMsg.FAIL.code) {
                    showAlert({title: "경고", text: "통신이 지연되고 있습니다.", type: "warning"});
                }
            })
            .catch((error) => {
            });
    }

    return (
        <div>
            <form className="input_wrap">
                <Grid paddingX={0}>
                    <GridChild>
                        <LabelInput label={'Group Code'} defaultValue={selectedCode1.groupCode} {...register("groupCode")} readOnly />
                    </GridChild>
                    <GridChild>
                        <LabelInput 
                            label={'Parent Code'} 
                            defaultValue={type === 'Level 2' ? selectedCode1?.name : selectedCode2?.name} 
                            {...register("parent")} 
                            readOnly 
                        />
                    </GridChild>
                    <GridChild>
                        <LabelInput 
                            label={'Depth'} 
                            defaultValue={type === 'Level 2' ? 2 : 3}
                            {...register("depth")} 
                            readOnly 
                        />
                    </GridChild>
                    <GridChild>
                        <LabelInput 
                            label={'코드명'} 
                            {...register("name")}
                            required
                            autoFocus
                        />
                    </GridChild>
                    <GridChild span={2}>
                        <LabelInput 
                            label={'Comment'} 
                            {...register("comment")} 
                        />
                    </GridChild>
                </Grid>
            </form>
            <Spacer direction='vertical' size={22} />

            <ToggleButtonSelect
                label="사용여부"
                name="usage_status"
                options={useYnOption}
                onChange={(value) => setUseYn(value)}
                initialValue={useYn}
            />

            <Spacer direction='vertical' size={22} />

            <Flex flexDirection={isMobile ? "column" : "row"} fullWidth justifyContent="end" gap={10}>
                <ModalButton type='insert' onClick={handleSubmit(onSubmitHandler)} />
                <ModalButton type='cancel' onClick={rendering} />
            </Flex>
        </div>
    );
}

export default CodeAddModal;